import { Injectable } from '@angular/core';
import { ApiService, Carrier } from '../../core';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class CarrierService {
    constructor(private apiService: ApiService) {
    }

    getCarriers(carrierRequest: string): Observable<Carrier[]> {
        const api = this.apiService.dispatch + '/findCarrierByFilters?' + carrierRequest;
        return this.apiService.get(
            api).pipe(
                map(data => data)
            );
    }

    getCarrierById(id): Observable<any> {
        return this.apiService.get(this.apiService.businessDispatchRead + `/carrierbyid/${id}`
        ).pipe(
            map(data => data)
        );
    }

    getPlates(): Observable<any> {
        return this.apiService.get(this.apiService.dispatch + '/plates').pipe(
            map(data => data)
        );
    }


    saveCarrier(carrier: Carrier): Observable<Carrier> {
        return this.apiService.post(this.apiService.carriers, carrier).pipe(
            map(data => data)
        );
    }

    getCourriersEntitiesAsociatedByCompanyCode(companyCode : string): Observable<Carrier> {
        const api = this.apiService.dispatch + `/courriersEntities/search?companyCode=${companyCode}`;
        return this.apiService.get(
            api).pipe(
                map(data => data)
            );
    }

    updateCarrier(carrier: Carrier): Observable<Carrier> {
        return this.apiService.put(this.apiService.carriers, carrier).pipe(
            map(data => data)
        );
    }

    getListCarriers(): Observable<any> {
        return this.apiService.get(this.apiService.businessDispatchRead + '/carriers').pipe(
            map(data => data)
        );
    }
    getValidCarrierNotify(carrieId: any): Observable<any> {
      return this.apiService.get(this.apiService.customerIntegration + `/application/currier/${carrieId}`).pipe(
          map(data => data)
        );
    }
}
